import Character from "../../character/Character";
import GridTile from "../../grid/GridTile";
import PathPlan from "./PathPlan";

export default class PathPlanJumpUp extends PathPlan {
    /**
     * @param {GridTile} startTile 
     * @param {GridTile} endTile 
     * @param {number} pathSteps
     */
    constructor(startTile, endTile, pathSteps) {
        super(startTile, endTile, pathSteps);
    }

    /**
     * @override
     * @param {Character} character 
     * @param {number} frameTimeRatio 
     * @param {boolean} turnStart True if this is the start of a turn.
     * @return {boolean} True when the step is completed.
     */
    executePlan(character, frameTimeRatio, turnStart) {

        /////////////////////////////////////////////
        // Jump up
        /////////////////////////////////////////////
        
        const result = this.jumpUp(character, frameTimeRatio, this.endTile);

        if (result) {
            this.assertEndTileReached(character, this.endTile);
        }

        return result;
    }
    
    /**
     * @returns {String}
     */
    toString() {
        return 'JumpUp(' + this.pathSteps + ')';
    }
}